/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import Shimmer from 'react-shimmer-effect';
import moment from 'moment';
import { useSelector, useDispatch, batch } from 'react-redux';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import SharedSingleDayQuestionnaireGrid from '../../../../shared/components/SportsHub/SharedSingleDayQuestionnaireGrid';
import SharedMultiDayQuestionnaireGrid from '../../../../shared/components/SportsHub/SharedMultiDayQuestionnaireGrid';
import DownloadReportButton from './DownloadReportButton';
import {
  setCurrentQuestionInQuestionnairePicker,
  setCurrentDateInDashDatePicker,
  setCurrentGroupInGroupPicker,
  setCurrentAthleteInAthletePicker,
  fetchQuestionnaireReportSingleDay,
  fetchLoadMonitoringLineChartData,
  fetchQuestionnaireReportMultiDay,
  setAthletesInClickedZone,
  setChartDayRange,
  setIsDashboardDisplayed,
} from '../../ducks/loadMonitoringDashboardActions';
import PickerAndDonutChart from './PickerAndDonutChart';
import Picker from '../../../../shared/components/SportsHub/Picker';
import TBDatePicker from '../../../../shared/components/TBDatePicker/TBDatePicker';
import Text from '../../../../shared/components/Text/Text';
import LoadMonitoringComposedChart from './LoadMonitoringComposedChart';
import SpiderChart from './SpiderChart';
import CheckboxFilterComponent from './CheckboxFilterComponent';
import WarningComponent from './WarningComponent';
import dummyAthleteData from './dummyAthleteData';
import { BoxShadow } from '../../../../shared/GlobalStyles';
import { dashboardTracker } from '../../../../shared/utils/amplitudeHelper';

const MainContainer = styled('main')`
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.containerWidth < 424 ? '15px' : '0px 25px')};
  width: 100%;
`;

const GraphAndPickersContainer = styled('div')`
  display: flex;
  flex-direction: column;
  background: ${(props) => (props.containerWidth < 424 ? '#F5F3F3' : '#F5F3F3')};
  border-radius: 20px;
  margin-bottom: 30px;
  gap: 20px;
`;

const PickerHeaderRow = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
`;

const DaySelector = styled('div')`
  display: flex;
  padding: 8px 10px;
  border-radius: 6px;
  box-shadow: ${BoxShadow};
  margin-right: 10px;
  background-color: #fff;
  max-width: max-content;
`;

const DayOption = styled('button')`
  border: none;
  font-family: 'Nunito Sans';
  font-size: 16px;
  color: ${(props) => (!props.isActive ? '#9E9E9E' : null)};
`;

const DaySpacer = styled('span')`
  color: #9e9e9e;
  font-family: 'Nunito Sans';
  font-size: 16px;
  margin: 0px 5px;
`;

const PickerHeaderSubContainerRow = styled('div')`
  display: flex;
  flex-direction: row;
  background: #ffffff;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05),
    0px 8px 16px rgba(48, 49, 51, 0.1);
  border-radius: 24px;
  width: ${(props) => props.containerWidth < 575 && '100%'};
  max-width: ${(props) => (props.containerWidth < 1035 && props.containerWidth > 575
    ? '240px'
    : 'max-content')};
  padding: ${(props) => (props.containerWidth < 301
    ? '15px'
    : props.containerWidth > 301 && props.containerWidth < 1035
      ? '25px'
      : '10px 25px')};
  align-items: center;
  gap: ${(props) => (props.containerWidth < 1035 ? '30px' : '15px')};
  flex-wrap: wrap;
  flex-grow: 1;
`;

const AthletePickerAndSelectedQuestionsSubRow = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap;
`;

const PickerAndDescriptionContainer = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 414 ? 'column' : 'row')};
  align-items: ${(props) => props.containerWidth >= 414 && 'center'};
  gap: ${(props) => (props.containerWidth < 424 ? '0px' : '15px')};
  flex-wrap: wrap;
  width: ${(props) => props.containerWidth < 1035 && '100%'};
  justify-content: ${(props) => props.containerWidth < 1035 && 'space-between'};
`;

const RowWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 40px;
  flex-wrap: ${(props) => props.containerWidth < 850 && 'wrap'};
  padding-bottom: 20px;
`;

const BodyRow = styled('div')`
  display: flex;
  flex-direction: row;
  margin-bottom: 60px;
  height: max-content;
  overflow-x: ${(props) => (props.containerWidth < 510 ? 'scroll' : 'hidden')};
  background: #f5f3f3;
`;

const ChartRow = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const RelativelyPositionedRowWrapperForScrollIndicator = styled('div')`
  display: flex;
  flex-direction: row;
  height: max-content;
  position: relative;
  height: max-content;
  overflow-x: hidden;
`;

const GridTitleRow = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 30px;
  margin-bottom: 30px;
`;

const GridLoadingShimmerPlaceHolder = styled('div')`
  display: flex;
  flex-direction: row;
  height: 400px;
  width: 100vw;
  border-radius: 20px;
`;

const PlaceHolderForAthletePickerShimmerLoading = styled('div')`
  min-width: 150px;
  height: 21px;
  border-radius: 12px;
  padding: 8px;
  background-color: #ff6600;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05),
    0px 4px 8px rgba(48, 49, 51, 0.1);
`;

const PickerDonutChartAndDownloadContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  margin-top: ${(props) => props.containerWidth >= 850
    && props.columnHeaderHeight
    && `${props.columnHeaderHeight}px`};
  width: ${(props) => props.containerWidth < 850 && '100%'};
`;

const BadgeButton = styled('button')`
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'white')};
  border: none;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 12px;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05),
    0px 4px 8px rgba(48, 49, 51, 0.1);
  display: flex;
  max-width: fit-content;
  align-items: center;
  gap: 15px;
`;

const TitleAndBadgeContainer = styled('div')`
  display: flex;
  gap: ${(props) => (props.isAthlete ? '0px' : '15px')};
  flex-wrap: wrap;
  flex-direction: ${(props) => (props.isAthlete ? 'column' : 'row')};
`;

const GeneratedDataPage = ({ containerWidth, setActivePage, formProps }) => {
  const dispatch = useDispatch();
  const gridRowRef = useRef(null);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const { accountCode } = currentUser;
  const activeTemplate = useSelector(
    (state) => state.loadMonitoringDashboard.data.activeTemplate,
  );
  const isLoadingQuestionnaireReportSingleDay = useSelector(
    (state) => state.loadMonitoringDashboard.ui.isLoadingQuestionnaireReportSingleDay,
  );
  const isLoadingQuestionnaireReportMultiday = useSelector(
    (state) => state.loadMonitoringDashboard.ui.isLoadingQuestionnaireReportMultiday,
  );
  const athletesAssociatedWithCurrentGroup = useSelector(
    (state) => state.loadMonitoringDashboard.data.athletesAssociatedWithCurrentGroup,
  );

  const lineChartData = useSelector(
    (state) => state.loadMonitoringDashboard.data.loadMonitoringLineChartData,
  );

  const athletesInClickedZone = useSelector(
    (state) => state.loadMonitoringDashboard.data.athletesInClickedZone,
  );
  const currentQuestionInDonutChartQuestionnairePicker = useSelector(
    (state) => state.loadMonitoringDashboard.data
      .currentQuestionInDonutChartQuestionnairePicker,
  );
  const thresholdFilterColor = athletesInClickedZone.length
    && athletesInClickedZone[0].questions.filter(
      (question) => question.id === currentQuestionInDonutChartQuestionnairePicker.id,
    )[0].response.backgroundColor;

  /** state to track for dash change Api calls */
  const currentDateInDashDatePicker = useSelector(
    (state) => state.loadMonitoringDashboard.data.currentDateInDashDatePicker,
  );
  const currentGroupInGroupPicker = useSelector(
    (state) => state.loadMonitoringDashboard.data.currentGroupInGroupPicker,
  );
  const currentAthleteInAthletePicker = useSelector(
    (state) => state.loadMonitoringDashboard.data.currentAthleteInAthletePicker,
  );
  const currentReportType = useSelector(
    (state) => state.loadMonitoringDashboard.data.currentReportType,
  );
  const reportableGroups = useSelector(
    (state) => state.loadMonitoringDashboard.data.reportableGroups,
  );
  /** props to pass to grids */
  const dataRows = useSelector(
    (state) => state.loadMonitoringDashboard.data.questionnaireReportData.dataRows,
  );
  const filteredDataRows = dataRows?.filter(
    (athlete) => athletesInClickedZone.indexOf(athlete) !== -1,
  );

  const teamAverageTotals = useSelector(
    (state) => state.loadMonitoringDashboard.data.questionnaireReportData
      .teamAverageTotals,
  );
  const formResponses = useSelector(
    (state) => state.loadMonitoringDashboard.data.loadMonitoringFormValues,
  );
  const showAverages = activeTemplate
    ? activeTemplate.showAverages
    : formResponses?.showRangeAverages;
  const showTotals = activeTemplate
    ? activeTemplate.showTotals
    : formResponses?.showTotal;
  const apiUnformattedData = useSelector(
    (state) => state.loadMonitoringDashboard.data.questionnaireReportData.data,
  );
  // Newly implemented dayRange to control 7 or 28 days
  const dayRange = useSelector(
    (state) => state.loadMonitoringDashboard.data.dayRange,
  );

  const [columnHeaderHeight, setColumnHeaderHeight] = useState(null);

  const [rowIsScrollable, setIsRowScrollable] = useState(false);

  // Pass this into dummyAthleteData along with currentAthleteInAthletePicker in case of no athlete data
  const noAthleteDataQuestionsArray = activeTemplate
    ? activeTemplate?.questions
    : formResponses?.arrayOfQuestions || [];

  const emptyAthleteTableData = dummyAthleteData(
    noAthleteDataQuestionsArray,
    currentAthleteInAthletePicker,
  );

  const handleScroll = () => {
    /** targetting the grid row container div scroll properties */
    const scrollWidth = gridRowRef.current?.scrollWidth;
    const offsetWidth = gridRowRef.current?.offsetWidth;
    const scrollLeft = gridRowRef.current?.scrollLeft;
    setIsRowScrollable(offsetWidth + scrollLeft !== scrollWidth);
  };

  useEffect(() => {
    if (gridRowRef.current) {
      const scrollWidth = gridRowRef.current?.scrollWidth;
      const offsetWidth = gridRowRef.current?.offsetWidth;
      const scrollLeft = gridRowRef.current?.scrollLeft;
      setIsRowScrollable(offsetWidth + scrollLeft !== scrollWidth);
    }
  }, [containerWidth]);

  const formattedListOfGroupsForGroupPicker = reportableGroups?.map((group) => {
    const obj = { ...group, displayText: group.name };
    return obj;
  });

  const formattedListOfAthletesForAthletePicker = athletesAssociatedWithCurrentGroup?.map(
    (athlete) => {
      const obj = { ...athlete, displayText: athlete.name, isAthlete: true };
      return obj;
    },
  );

  const formattedCurrentGroupInGroupPicker = {
    ...currentGroupInGroupPicker,
    displayText: currentGroupInGroupPicker.name,
  };

  const formattedListForSelectedQuestionsPicker = [
    {
      displayText: 'All Questions From Selected Questionnaire',
      id: 'selectAllQuestions',
    },
    { displayText: 'Individual Questions', id: 'selectIndividualQuestions' },
  ];

  const getVisibleContainerItemForSelectedQuestionsPicker = () => {
    if (activeTemplate && activeTemplate.isQuestionnaire) return activeTemplate.questionnaire.title;
    if (
      (activeTemplate && !activeTemplate.isQuestionnaire)
      || formResponses?.selectionType === 'selectIndividualQuestions'
    ) {
      return 'Individual Questions';
    }
    return 'All Questions From Selected Questionnaire';
  };

  /** any time the user changes the date, changes the group, or changes the athlete, we need
   * to make another call to the one of the grid APIs to get the updated data
   * to do this we will set up a function called handleGridAPICall()=> this function will check if the current athlete in the picker
   * if the current athlete in the picker is a group, then it will make a call to the single day grid
   * if the current ahtlete in the picker is actually an athlete, then it will make a call to the multiday grid
   * athletes will have a userId, and groups will just have an id
   * group fiter value is 2, athlete filter value is 1
   */
  const handleGridAPICall = (item, infoForAPICall) => {
    /** set filterType and filterIds based on item being passed */

    if (item?.isAthlete) {
      // Amplitude tracking
      dashboardTracker(
        'Load Monitoring Dashboard',
        'Generated Data Page',
        'Athlete data fetched',
      );
      /** get start and end date for 7 days prior to date in date picker */
      const dateInPicker = infoForAPICall.date.date;
      const sevenDaysBeforeDateInPicker = new Date(
        new Date(dateInPicker).setDate(new Date(dateInPicker).getDate() - 6),
      );
      const twentyEightDaysBeforeDateInPicker = new Date(
        new Date(dateInPicker).setDate(new Date(dateInPicker).getDate() - 28),
      );

      const dateToUse = dayRange === 7
        ? sevenDaysBeforeDateInPicker
        : twentyEightDaysBeforeDateInPicker;

      const startDateObj = {
        date: dateToUse,
        queryFormat: moment(dateToUse).format('YYYY-MM-DD'),
      };

      /** filter types to pass to endpoint */
      const filterType = 1;
      const filterIds = [item.userId];

      /** values to pass to endpoint */
      const values = {
        selectionType: infoForAPICall.selectionType,
        startDate: startDateObj,
        date: infoForAPICall.date,
        questionnaire: infoForAPICall.questionnaire,
        arrayOfQuestions: infoForAPICall.arrayOfQuestions,
        showRangeAverages: infoForAPICall.showRangeAverages,
        showTotal: infoForAPICall.showTotal,
        dayRange: infoForAPICall.dayRange,
      };

      dispatch(
        fetchQuestionnaireReportMultiDay(
          accountCode,
          filterType,
          filterIds,
          values,
        ),
      );
      /** everytime we make a call to the grid api with changes we also need to
       * make a call to the line chart to reflect those chages
       */
      dispatch(
        fetchLoadMonitoringLineChartData(
          accountCode,
          filterType,
          filterIds,
          infoForAPICall,
        ),
      );
    } else {
      // Amplitude tracking
      dashboardTracker(
        'Load Monitoring Dashboard',
        'Generated Data Page',
        'Group data fetched',
      );
      const filterType = 2;
      const filterIds = [item.id];

      dispatch(
        fetchQuestionnaireReportSingleDay(
          accountCode,
          filterType,
          filterIds,
          infoForAPICall,
        ),
      );
      /** everytime we make a call to the grid api with changes we also need to
       * make a call to the line chart to reflect those chages
       */
      dispatch(
        fetchLoadMonitoringLineChartData(
          accountCode,
          filterType,
          filterIds,
          infoForAPICall,
        ),
      );
    }
  };

  const selectionType = () => {
    if (activeTemplate && activeTemplate.isQuestionnaire) return 'selectAllQuestions';
    if (activeTemplate && !activeTemplate.isQuestionnaire) return 'selectIndividualQuestions';
    return formResponses.selectionType;
  };

  const setActiveDate = (date) => {
    // Amplitude tracking
    dashboardTracker(
      'Load Monitoring Dashboard',
      'Date Picker',
      'Date selected',
    );
    dispatch(
      setCurrentDateInDashDatePicker({
        date,
        queryFormat: moment(date).format('YYYY-MM-DD'),
      }),
    );
    const infoForAPICall = {
      selectionType: selectionType(),
      date: {
        date,
        queryFormat: moment(date).format('YYYY-MM-DD'),
      },
      questionnaire: activeTemplate
        ? activeTemplate.questionnaire
        : formResponses.questionnaire,
      arrayOfQuestions: activeTemplate
        ? activeTemplate.questions
        : formResponses.arrayOfQuestions,
      showRangeAverages: showAverages,
      showTotal: showTotals,
      dayRange,
    };
    if (reportableGroups?.length) {
      handleGridAPICall(currentAthleteInAthletePicker, infoForAPICall);
    }
  };

  // Trigger API call when day range changed same as changing athlete, group, or selected date
  const handleDayClick = (days) => {
    dispatch(setChartDayRange(days));
    // Amplitude tracking
    dashboardTracker(
      'Load Monitoring Dashboard',
      'Day Range Toggle',
      `Range of ${days} days selected`,
    );
    const infoForAPICall = {
      selectionType: selectionType(),
      date: currentDateInDashDatePicker,
      questionnaire: activeTemplate
        ? activeTemplate.questionnaire
        : formResponses.questionnaire,
      arrayOfQuestions: activeTemplate
        ? activeTemplate.questions
        : formResponses.arrayOfQuestions,
      showRangeAverages: showAverages,
      showTotal: showTotals,
      dayRange: days,
    };
    if (reportableGroups?.length) {
      handleGridAPICall(currentAthleteInAthletePicker, infoForAPICall);
    }
  };

  const functionForAthletePicker = (item) => {
    // Amplitude tracking
    dashboardTracker(
      'Load Monitoring Dashboard',
      'Athlete Picker',
      'Athlete selection changed',
    );
    dispatch(setCurrentAthleteInAthletePicker(item));
    const infoForAPICall = {
      selectionType: selectionType(),
      date: currentDateInDashDatePicker,
      questionnaire: activeTemplate
        ? activeTemplate.questionnaire
        : formResponses.questionnaire,
      arrayOfQuestions: activeTemplate
        ? activeTemplate.questions
        : formResponses.arrayOfQuestions,
      showRangeAverages: showAverages,
      showTotal: showTotals,
      dayRange,
    };
    handleGridAPICall(item, infoForAPICall);
  };

  const functionForGroupPicker = (item) => {
    // Amplitude tracking
    dashboardTracker(
      'Load Monitoring Dashboard',
      'Group Picker',
      'Group selected',
    );
    dispatch(setCurrentGroupInGroupPicker(item));
    dispatch(setCurrentAthleteInAthletePicker(item));

    const infoForAPICall = {
      selectionType: selectionType(),
      date: currentDateInDashDatePicker,
      questionnaire: activeTemplate
        ? activeTemplate.questionnaire
        : formResponses.questionnaire,
      arrayOfQuestions: activeTemplate
        ? activeTemplate.questions
        : formResponses.arrayOfQuestions,
      showRangeAverages: showAverages,
      showTotal: showTotals,
      dayRange,
    };
    handleGridAPICall(item, infoForAPICall);
  };

  const functionForSelectedQuestionsPicker = (item) => {
    // Amplitude tracking
    dashboardTracker(
      'Load Monitoring Dashboard',
      'Selected Questions Picker',
      'Question selection selected',
    );
    batch(() => {
      dispatch(setIsDashboardDisplayed(false));
      dispatch(setChartDayRange(7));
    });
    formProps.setValues({
      questionnaire: null,
      questionnaireIds: [],
      arrayOfQuestions: [],
      questionIds: [
        { title: '', id: '' },
        { title: '', id: '' },
        { title: '', id: '' },
        { title: '', id: '' },
        { title: '', id: '' },
      ],
      selectionType: item.id,
      date: { ...formResponses.date },
      showRangeAverages: formResponses.showRangeAverages,
      showTotal: formResponses.showTotal,
      dayRange: 7,
    });
    // If current dash already has individual questions and user selects individual questions, pre-populate form with existing selections
    if (
      item.id === 'selectIndividualQuestions'
      && formResponses.selectionType === 'selectIndividualQuestions'
    ) {
      const newQuestionIds = formResponses.arrayOfQuestions.map(
        (questionObj) => ({
          id: questionObj.id,
          title: questionObj.title,
        }),
      );
      // Fill questionIds with empty objects until the length is 5
      while (newQuestionIds.length < 5) {
        newQuestionIds.push({ title: '', id: '' });
      }
      formProps.setFieldValue('questionIds', newQuestionIds);
    }
    // If current dash already has selected questionnaire and user selects All Questions, pre-select the questionnaire
    if (item.id === 'selectAllQuestions' && formResponses.questionnaire) {
      formProps.setFieldValue('questionnaire', formResponses.questionnaire);
      formProps.setFieldValue('questionnaireIds', [
        formResponses.questionnaire?.id,
      ]);
    }
    formProps.setErrors({});
    formProps.setTouched({});
    setActivePage(2);
  };

  /** clear the threshold filter everytime the user manipulates a data point */
  useEffect(() => {
    dispatch(setAthletesInClickedZone([]));
  }, [
    currentQuestionInDonutChartQuestionnairePicker,
    currentGroupInGroupPicker,
    currentAthleteInAthletePicker,
    currentDateInDashDatePicker,
  ]);

  return (
    <MainContainer containerWidth={containerWidth}>
      {containerWidth < 1035 ? (
        <GraphAndPickersContainer containerWidth={containerWidth}>
          <PickerHeaderRow
            style={{ flexWrap: containerWidth < 575 ? 'wrap' : 'nowrap' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                height: containerWidth > 574 ? '100%' : 'fit-content',
              }}
            >
              <TBDatePicker
                activeDate={currentDateInDashDatePicker?.date}
                setActiveDate={setActiveDate}
                additionalStyles={{
                  justifyContent: 'flex-start',
                  margin: '0px',
                  maxWidth: '240px',
                }}
              />
              <DaySelector>
                <DayOption
                  type='button'
                  isActive={dayRange === 7}
                  onClick={() => handleDayClick(7)}
                >
                  7D
                </DayOption>
                <DaySpacer> | </DaySpacer>
                <DayOption
                  type='button'
                  isActive={dayRange === 28}
                  onClick={() => handleDayClick(28)}
                >
                  28D
                </DayOption>
              </DaySelector>
              {reportableGroups.length ? (
                <PickerHeaderSubContainerRow containerWidth={containerWidth}>
                  <PickerAndDescriptionContainer
                    containerWidth={containerWidth}
                    style={{
                      borderRight:
                        containerWidth < 1035 ? 'none' : '2px solid #D9D9D9',
                      paddingRight: containerWidth < 1035 ? '0px' : '15px',
                    }}
                  >
                    <Text fontSize='15px' fontWeight={700}>
                      {' '}
                      Group:
                    </Text>
                    <Picker
                      list={formattedListOfGroupsForGroupPicker}
                      reduxFunction={functionForGroupPicker}
                      visibleContainerItem={
                        currentGroupInGroupPicker?.displayText
                      }
                      icon={{ name: 'swap', size: 16, color: 'white' }}
                      pickerButtonColor='#444444'
                      pickerFontColor='white'
                      minWidth={190}
                      height={34}
                      itemPickerContainerMaxWidth={containerWidth < 414 && 200}
                      absoluteLeftPositioningOfItemPickerContainer={
                        containerWidth < 575 && containerWidth >= 414 && -100
                      }
                      addSearchBar
                    />
                  </PickerAndDescriptionContainer>
                  <AthletePickerAndSelectedQuestionsSubRow>
                    <PickerAndDescriptionContainer
                      containerWidth={containerWidth}
                    >
                      <Text fontSize='15px' fontWeight={700}>
                        {' '}
                        Currently Viewing:
                      </Text>
                      {isLoadingQuestionnaireReportMultiday
                      || isLoadingQuestionnaireReportSingleDay ? (
                        <Shimmer>
                          <PlaceHolderForAthletePickerShimmerLoading />
                        </Shimmer>
                        ) : (
                          <Picker
                            list={[
                              { ...formattedCurrentGroupInGroupPicker },
                              ...formattedListOfAthletesForAthletePicker,
                            ]}
                            reduxFunction={functionForAthletePicker}
                            visibleContainerItem={
                            currentAthleteInAthletePicker?.displayText
                          }
                            icon={{ name: 'swap', size: 16, color: '#444444' }}
                            pickerButtonColor='#EEEEEE'
                            pickerFontColor='#444444'
                            small
                            minWidth={150}
                            itemPickerContainerMaxWidth={
                            containerWidth < 420 && 200
                          }
                            absoluteLeftPositioningOfItemPickerContainer={
                            containerWidth < 575
                            && containerWidth >= 414
                            && -100
                          }
                            addSearchBar
                          />
                        )}
                    </PickerAndDescriptionContainer>
                    <PickerAndDescriptionContainer
                      containerWidth={containerWidth}
                    >
                      <Text fontSize='15px' fontWeight={700}>
                        {!!activeTemplate && !!activeTemplate.isQuestionnaire
                          ? 'Selected Questionnaire:'
                          : 'Selected Questions:'}
                      </Text>
                      <Picker
                        disabled={!!activeTemplate}
                        list={formattedListForSelectedQuestionsPicker}
                        reduxFunction={functionForSelectedQuestionsPicker}
                        visibleContainerItem={getVisibleContainerItemForSelectedQuestionsPicker()}
                        icon={
                          activeTemplate
                            ? {}
                            : { name: 'swap', size: 16, color: '#444444' }
                        }
                        pickerButtonColor='#EEEEEE'
                        pickerFontColor='#444444'
                        small
                        minWidth={150}
                        itemPickerContainerMaxWidth={
                          containerWidth < 420 && 200
                        }
                        absoluteLeftPositioningOfItemPickerContainer={
                          containerWidth < 575 && containerWidth >= 414 && -100
                        }
                      />
                    </PickerAndDescriptionContainer>
                  </AthletePickerAndSelectedQuestionsSubRow>
                </PickerHeaderSubContainerRow>
              ) : (
                <WarningComponent
                  containerWidth={containerWidth}
                  message='Oops! Something went wrong. We were not able to find any reportable groups. Please check the status of your user groups and make sure reporting is enabled.'
                />
              )}
            </div>
            <SpiderChart
              maxHeight='500px'
              alignSelf='flex-end'
              containerWidth={containerWidth}
              showAverages={showAverages}
            />
          </PickerHeaderRow>
          <ChartRow
            style={{ flexWrap: containerWidth < 768 ? 'wrap' : 'nowrap' }}
          >
            <LoadMonitoringComposedChart
              containerWidth={containerWidth}
              lineChartData={lineChartData}
            />
            <CheckboxFilterComponent
              containerWidth={containerWidth}
              renderTooltip={!(containerWidth < 768) && !!lineChartData?.length}
              lineChartData={lineChartData || []}
            />
          </ChartRow>
        </GraphAndPickersContainer>
      ) : (
        <>
          <GraphAndPickersContainer containerWidth={containerWidth}>
            <PickerHeaderRow>
              <TBDatePicker
                activeDate={currentDateInDashDatePicker?.date}
                setActiveDate={setActiveDate}
                additionalStyles={{
                  justifyContent: 'flex-start',
                  margin: '0px',
                  maxWidth: '240px',
                }}
              />
              <DaySelector>
                <DayOption
                  type='button'
                  isActive={dayRange === 7}
                  onClick={() => handleDayClick(7)}
                >
                  7D
                </DayOption>
                <DaySpacer> | </DaySpacer>
                <DayOption
                  type='button'
                  isActive={dayRange === 28}
                  onClick={() => handleDayClick(28)}
                >
                  28D
                </DayOption>
              </DaySelector>
              {reportableGroups.length ? (
                <PickerHeaderSubContainerRow containerWidth={containerWidth}>
                  <PickerAndDescriptionContainer
                    containerWidth={containerWidth}
                    style={{
                      borderRight:
                        containerWidth < 1035 ? 'none' : '2px solid #D9D9D9',
                      paddingRight: containerWidth < 1035 ? '0px' : '15px',
                    }}
                  >
                    <Text fontSize='15px' fontWeight={700}>
                      {' '}
                      Group:
                    </Text>
                    <Picker
                      list={formattedListOfGroupsForGroupPicker}
                      reduxFunction={functionForGroupPicker}
                      visibleContainerItem={
                        currentGroupInGroupPicker?.displayText
                      }
                      icon={{ name: 'swap', size: 16, color: 'white' }}
                      pickerButtonColor='#444444'
                      pickerFontColor='white'
                      minWidth={190}
                      height={34}
                      addSearchBar
                    />
                  </PickerAndDescriptionContainer>
                  <AthletePickerAndSelectedQuestionsSubRow>
                    <PickerAndDescriptionContainer
                      containerWidth={containerWidth}
                    >
                      <Text fontSize='15px' fontWeight={700}>
                        {' '}
                        Currently Viewing:
                      </Text>
                      {isLoadingQuestionnaireReportMultiday
                      || isLoadingQuestionnaireReportSingleDay ? (
                        <Shimmer>
                          <PlaceHolderForAthletePickerShimmerLoading />
                        </Shimmer>
                        ) : (
                          <Picker
                            list={[
                              { ...formattedCurrentGroupInGroupPicker },
                              ...formattedListOfAthletesForAthletePicker,
                            ]}
                            reduxFunction={functionForAthletePicker}
                            visibleContainerItem={
                            currentAthleteInAthletePicker?.displayText
                          }
                            icon={{ name: 'swap', size: 16, color: '#444444' }}
                            pickerButtonColor='#EEEEEE'
                            pickerFontColor='#444444'
                            small
                            minWidth={150}
                            addSearchBar
                          />
                        )}
                    </PickerAndDescriptionContainer>
                    <PickerAndDescriptionContainer
                      containerWidth={containerWidth}
                    >
                      <Text fontSize='15px' fontWeight={700}>
                        {!!activeTemplate && !!activeTemplate.isQuestionnaire
                          ? 'Selected Questionnaire:'
                          : 'Selected Questions:'}
                      </Text>
                      <Picker
                        disabled={!!activeTemplate}
                        list={formattedListForSelectedQuestionsPicker}
                        reduxFunction={functionForSelectedQuestionsPicker}
                        visibleContainerItem={getVisibleContainerItemForSelectedQuestionsPicker()}
                        icon={
                          activeTemplate
                            ? {}
                            : { name: 'swap', size: 16, color: '#444444' }
                        }
                        pickerButtonColor='#EEEEEE'
                        pickerFontColor='#444444'
                        small
                        minWidth={containerWidth < 1084 ? 150 : 200}
                        absoluteLeftPositioningOfItemPickerContainer={-100}
                      />
                    </PickerAndDescriptionContainer>
                  </AthletePickerAndSelectedQuestionsSubRow>
                </PickerHeaderSubContainerRow>
              ) : (
                <WarningComponent
                  containerWidth={containerWidth}
                  message='Oops! Something went wrong. We were not able to find any reportable groups. Please check the status of your user groups and make sure reporting is enabled.'
                />
              )}
            </PickerHeaderRow>
            <ChartRow>
              <SpiderChart
                maxWidth='275px'
                containerWidth={containerWidth}
                showAverages={showAverages}
              />
              <LoadMonitoringComposedChart
                containerWidth={containerWidth}
                lineChartData={lineChartData}
              />
              <CheckboxFilterComponent
                containerWidth={containerWidth}
                renderTooltip={!!lineChartData?.length}
                lineChartData={lineChartData || []}
              />
            </ChartRow>
          </GraphAndPickersContainer>
        </>
      )}
      {!!reportableGroups?.length
      && ((currentReportType === 'singleDay' && !!dataRows?.length)
        || currentReportType === 'multiDay') ? (
          <>
            <GridTitleRow>
              <TitleAndBadgeContainer
                isAthlete={currentAthleteInAthletePicker?.isAthlete}
              >
                <Text fontWeight={700} fontSize='16px'>
                  {' '}
                  {currentAthleteInAthletePicker?.isAthlete
                    ? 'Athlete'
                    : 'Group'}
                  {' '}
                  Report -
                  {' '}
                  {currentAthleteInAthletePicker?.name}
                  {' '}
                  {currentAthleteInAthletePicker?.isAthlete
                    ? null
                    : `(${moment(currentDateInDashDatePicker?.date).format(
                      'MMM DD, YYYY',
                    )})`}
                </Text>
                {currentAthleteInAthletePicker?.isAthlete && (
                <Text fontSize='11px' fontWeight={700}>
                  {dataRows?.length
                    ? `Last ${dayRange} days that data was found for current athlete
                  before selected date`
                    : 'No data found for current athlete before selected date. Please adjust your selections above and try again.'}
                </Text>
                )}
                {athletesInClickedZone.length ? (
                  <BadgeButton
                    type='button'
                    onClick={() => dispatch(setAthletesInClickedZone([]))}
                    backgroundColor={thresholdFilterColor}
                  >
                    <Text color='white' fontSize='12px' fontWeight={700}>
                      Threshold Filter
                    </Text>
                    <IcomoonReact
                      iconSet={iconSet}
                      color='white'
                      size={8}
                      icon='remove'
                    />
                  </BadgeButton>
                ) : null}
              </TitleAndBadgeContainer>
              {currentReportType === 'multiDay' && !!dataRows?.length && (
              <DownloadReportButton
                backgroundColor='white'
                textColor='#444444'
                chartName={`Athlete Report - ${currentAthleteInAthletePicker?.name}`}
              />
              )}
            </GridTitleRow>
            <RowWrapper containerWidth={containerWidth}>
              {currentReportType === 'singleDay' && (
              <PickerDonutChartAndDownloadContainer
                columnHeaderHeight={columnHeaderHeight}
                containerWidth={containerWidth}
              >
                <PickerAndDonutChart containerWidth={containerWidth} />
                <DownloadReportButton
                  chartName={`Group Report - ${
                    currentAthleteInAthletePicker?.name
                  } (${moment(currentDateInDashDatePicker?.date).format(
                    'MMM DD, YYYY',
                  )}) `}
                />
              </PickerDonutChartAndDownloadContainer>
              )}
              <RelativelyPositionedRowWrapperForScrollIndicator>
                <BodyRow
                  containerWidth={containerWidth}
                  ref={gridRowRef}
                  onScroll={handleScroll}
                  rowIsScrollable={rowIsScrollable}
                >
                  {isLoadingQuestionnaireReportMultiday
                || isLoadingQuestionnaireReportSingleDay ? (
                  <Shimmer>
                    <GridLoadingShimmerPlaceHolder />
                  </Shimmer>
                    ) : (
                      <>
                        {currentReportType === 'singleDay' && (
                        <SharedSingleDayQuestionnaireGrid
                          setColumnHeaderHeight={setColumnHeaderHeight}
                          containerWidth={containerWidth}
                          dataRows={
                          athletesInClickedZone?.length
                            ? filteredDataRows
                            : dataRows
                        }
                          teamAverageTotals={teamAverageTotals}
                          showAverages={showAverages}
                          showTotals={showTotals}
                          setCurrentQuestionInDonutChartQuestionnairePicker={
                          setCurrentQuestionInQuestionnairePicker
                        }
                          rowIsScrollable={rowIsScrollable}
                          athletesInClickedZone={athletesInClickedZone}
                        />
                        )}
                        {currentReportType === 'multiDay' && (
                        <>
                          <SharedMultiDayQuestionnaireGrid
                          containerWidth={containerWidth}
                          dataRows={
                            dataRows?.length ? dataRows : emptyAthleteTableData
                          }
                          apiUnformattedData={
                            dataRows?.length
                              ? apiUnformattedData
                              : emptyAthleteTableData
                          }
                          showAverages={showAverages}
                          showTotals={showTotals}
                          setColumnHeaderHeight={setColumnHeaderHeight}
                          rowIsScrollable={rowIsScrollable}
                        />
                        </>
                        )}
                      </>
                    )}
                </BodyRow>
              </RelativelyPositionedRowWrapperForScrollIndicator>
            </RowWrapper>
          </>
        ) : null}
    </MainContainer>
  );
};

export default GeneratedDataPage;
